module.exports = __webpack_public_path__ + "img/h数据保养.15bfc992.svg";